/**
 * CcEmailsSection — the Billing step's "Email forwarding" box.
 *
 * The list UI is the SHARED `EmailForwardning` component, the same one legacy's
 * Billing step uses. v2 had hand-rolled an input + Add button + MUI Chips beside
 * it, which is how the two drifted apart visually for no reason; the shared
 * component also owns its own draft state and validation, so this section no
 * longer threads either.
 *
 * The title is legacy's (`purchase_flow:billing_step.email_forwarding.title`);
 * the description is v2's own shorter copy (QA-566), saying the same two things:
 * the recipients get prices, and defaults live in profile settings.
 *
 * Validity is owned by `selectBillingStepValid`.
 * Cc-emails prefill from the user's/workspace saved CC list.
 */

import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { EmailForwardning } from 'components/common/EmailForwardning'
import { SectionedBorderBox } from 'components/common/SectionedBorderBox'


interface Props {
  value: string[]
  onChange: (next: string[]) => void
}

export const CcEmailsSection: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation(['purchase_flow', 'purchase_flow_revamp'])

  const handleDelete = useCallback(
    (email: string) => onChange(value.filter((entry) => entry !== email)),
    [onChange, value]
  )

  return (
    <SectionedBorderBox variant="flat"
      title={t('purchase_flow:billing_step.email_forwarding.title')}
      description={t('purchase_flow_revamp:billing.email_forwarding_description')}
    >
      <EmailForwardning
        ccEmails={value}
        onChange={onChange}
        onDelete={handleDelete}
      />
    </SectionedBorderBox>
  )
}
